var _g, _g2, _g3, _g4, _g5, _g6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconCursor(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_x3C_Group_x3E__4_",
    xmlns: "http://www.w3.org/2000/svg",
    width: 41.953,
    height: 41.953,
    viewBox: "0 0 41.953 41.953",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_6407",
    "data-name": "Group 6407",
    transform: "translate(14.943 14.941)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_13347",
    "data-name": "Path 13347",
    d: "M202.06,209l-7.171-7.17-3.476,3.476a1.228,1.228,0,0,1-2.035-.48l-6.953-20.859a1.228,1.228,0,0,1,1.554-1.554l20.859,6.953a1.228,1.228,0,0,1,.48,2.034l-3.476,3.476,7.17,7.171a1.229,1.229,0,0,1,0,1.738L203.8,209A1.228,1.228,0,0,1,202.06,209Z",
    transform: "translate(-182.362 -182.344)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_6408",
    "data-name": "Group 6408",
    transform: "translate(14.749)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_13348",
    "data-name": "Path 13348",
    d: "M181.229,9.833A1.228,1.228,0,0,1,180,8.6V1.229a1.229,1.229,0,0,1,2.458,0V8.6A1.228,1.228,0,0,1,181.229,9.833Z",
    transform: "translate(-180)"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Group_6409",
    "data-name": "Group 6409",
    transform: "translate(4.32 4.32)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_13349",
    "data-name": "Path 13349",
    d: "M58.3,60.033,53.08,54.818a1.229,1.229,0,1,1,1.738-1.738L60.033,58.3A1.229,1.229,0,0,1,58.3,60.033Z",
    transform: "translate(-52.72 -52.72)"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Group_6410",
    "data-name": "Group 6410",
    transform: "translate(4.32 19.963)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_13350",
    "data-name": "Path 13350",
    d: "M53.08,250.947a1.229,1.229,0,0,1,0-1.738l5.215-5.215a1.229,1.229,0,0,1,1.738,1.738l-5.215,5.215A1.229,1.229,0,0,1,53.08,250.947Z",
    transform: "translate(-52.72 -243.634)"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "Group_6411",
    "data-name": "Group 6411",
    transform: "translate(19.963 4.32)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_13351",
    "data-name": "Path 13351",
    d: "M243.993,60.034a1.229,1.229,0,0,1,0-1.738l5.215-5.215a1.229,1.229,0,1,1,1.738,1.738l-5.215,5.215A1.229,1.229,0,0,1,243.993,60.034Z",
    transform: "translate(-243.633 -52.721)"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "Group_6412",
    "data-name": "Group 6412",
    transform: "translate(0 14.749)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_13352",
    "data-name": "Path 13352",
    d: "M8.6,182.458H1.229a1.229,1.229,0,0,1,0-2.458H8.6a1.229,1.229,0,0,1,0,2.458Z",
    transform: "translate(0 -180)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCursor);
export default __webpack_public_path__ + "static/media/icon-cursor.647718104ebde83321cdbc86fdf16cff.svg";
export { ForwardRef as ReactComponent };